import { Component, Input, OnInit } from '@angular/core';
import { BaseProjectComponent } from '@layouts/default/layouts/logged/pages/project/components/base-project.component';
import {
  PhFiltersAction,
  PhFiltersDataEmitter,
  PhFiltersService,
} from '@shared/components/ph-filters/ph-filters.service';
import { FiltersParams } from '@shared/models/filters/filters-params.model';
import { UntypedFormGroup } from '@angular/forms';

@Component({
  selector: 'app-filter-featured',
  templateUrl: './filter-featured.component.html',
  styleUrls: ['./filter-featured.component.scss'],
})
export class FilterFeaturedComponent extends BaseProjectComponent implements OnInit {
  featured: boolean = false;
  @Input() correctForm: UntypedFormGroup = new UntypedFormGroup({});

  constructor(public filtersService: PhFiltersService) {
    super();
  }

  ngOnInit() {
    setTimeout(this.checkUrlParams.bind(this), 400);
  }

  onFeaturedChange() {
    this.updateParams();
  }

  get f() {
    return this.correctForm.get('filters_featured');
  }

  checkUrlParams() {
    const params: FiltersParams = this.filtersService.params;
    if (params.filters_featured) {
      this.f.patchValue(params.filters_featured, { emitEvent: '' });
    }
  }

  resetFeatured() {
    this.f.setValue(false);
    this.updateParams();
  }

  updateParams() {
    this.filtersService.filtersEmitter.emit(
      new PhFiltersDataEmitter({
        action: PhFiltersAction.UPDATE_PARAMS,
        params: {
          filters_featured: this.f.value ? this.f.value : '',
        },
      })
    );
  }
}
